import { render } from "./LongtermLegend.vue?vue&type=template&id=5dbe3549"
import script from "./LongtermLegend.vue?vue&type=script&lang=js"
export * from "./LongtermLegend.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__